import { Subscription } from '../../../../types/subscription';
import { Bot } from 'grts-utils/types/Bot';
import { useCalculateCurrentSingleProfitCalculationQuery } from '../../../../store/services/api';
import SingleProfitCalculationResult from '../../../ProfitCalculations/Content/SingleProfitCalculation/Result';
import LoadingIcons from 'react-loading-icons';

const initialIndicatorsConfig = {
  rsi: {
    higherT: {
      period: 5,
      threshold: 75,
      signalPosition: 1,
    },
    takeProfitT: {
      period: 9,
      threshold: 90,
    },
    shorterT: {
      period: 8,
      threshold: 85,
    },
    multiT: {
      period: 5,
      threshold: 90,
    },
  },
};

interface Props {
  subscription: Subscription;
  bot: Bot | undefined;
}

const Calculations = (props: Props) => {
  const { subscription } = props;

  const { data: spcResult, isLoading } =
    useCalculateCurrentSingleProfitCalculationQuery(subscription.baseAsset);

  if (isLoading) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadingIcons.Grid width={60} />
      </div>
    );
  }

  return (
    <div
      style={{
        flex: 1,
      }}
    >
      <SingleProfitCalculationResult
        data={spcResult?.data}
        indicatorConfig={initialIndicatorsConfig}
      />
    </div>
  );
};

export default Calculations;
